import angular from 'angular';
import changeColor from './changeColor';

export default angular
  .module('components.changeColor', [])
  .component('changeColor', changeColor).name;
